import { useNavigate } from 'react-router';
import { useLoginRequiredModal } from '@/entities/user';
import { Button } from '@/shared/ui';

type CarRegistrationBannerProps = {
	isLoggedIn: boolean;
};

const CarRegistrationBanner = ({ isLoggedIn }: CarRegistrationBannerProps) => {
	const navigate = useNavigate();
	const openLoginRequiredModal = useLoginRequiredModal();

	const handleClick = () => {
		if (isLoggedIn) {
			navigate('/profile/regist-car-intro');
			return;
		}

		openLoginRequiredModal();
	};

	return (
		<div className="mx-5 my-2 flex h-[72px] items-center justify-between rounded-[12px] bg-[#F4F4F4] px-5 py-4">
			<div className="flex min-w-0 flex-col justify-center">
				<span className="font-semibold text-[#353D4A] text-[16px] leading-5">
					내 차 정보를 등록하면
				</span>
				<span className="truncate font-normal text-[#8D95A0] text-[14px] leading-[18px]">
					절약 금액을 더 정확하게 계산해드려요
				</span>
			</div>
			<Button
				className="h-8 w-[62px] max-w-none shrink-0 rounded-xl px-0 py-0 text-sm shadow-none hover:shadow-none"
				onClick={handleClick}
			>
				등록하기
			</Button>
		</div>
	);
};

export default CarRegistrationBanner;
